import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AgGridModule } from "ag-grid-angular";
import { NgxSpinnerModule } from "ngx-spinner";
import { BadgeModule } from "primeng/badge";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DropdownModule } from "primeng/dropdown";
import { PickListModule } from "primeng/picklist";
import { InputTextModule } from "primeng/inputtext";
import { MultiSelectModule } from "primeng/multiselect";
import { SplitterModule } from "primeng/splitter";
import { ToastModule } from "primeng/toast";
import { ToolbarModule } from "primeng/toolbar";
import { TooltipModule } from "primeng/tooltip";
import { AuthGuardService } from "../services/auth-guard.service";
import { BreakdownRuleDropdownComponent } from "./breakdown-rule-dropdown.component";
import { BreakdownRuleLockComponent } from "./breakdown-rule-lock.component";
import { PositionCheckboxComponent } from "./position-checkbox.component";
import { ClientManagementComponent } from "./client-management.component";
import { EntityActionComponent } from "./entity-action.component";
import { EntityFormComponent } from "./entity-form.component";
import { ManageResourceComponent } from "./manage-resource.component";
import { PayCategoryDropdownComponent } from "./pay-category-dropdown.component";
import { PositionDropdownComponent } from "./position-dropdown.component";
import { DeleteActionComponent} from "./delete-action.component";
import { RosterCodeDropdownComponent } from "./roster-code-dropdown.component";
import { SystemDataManagementComponent } from "./system-data-management.component";
import { TimesheetBreakdownRuleComponent } from "./timesheet-breakdown-rule.component";
import { ManageRosterCodeComponent } from "./manage-roster-code.component";
import { RosterCodeCheckboxComponent } from "./roster-code-checkbox.component";
import { ManageHolidayComponent } from "./manage-holiday.component";
import { MessagesModule } from "primeng/messages";
import { PanelModule } from "primeng/panel";
import { ManageRosterSettingsComponent } from "./manage-roster-settings.component";
import { TabViewModule } from "primeng/tabview";
import { ManageRosterCodeSettingsComponent } from "./manage-roster-code-settings.component";
import { ManageRosterTypeComponent } from "./manage-roster-type.component";
import { FieldsetModule } from "primeng/fieldset";
import { MessageModule } from "primeng/message";
import { RosterTypeFormComponent } from "./roster-type-form.component";
import { InputTextareaModule } from "primeng/inputtextarea";
import { SharedModule } from "../shared/shared.module";
import { ManageWorkAreaComponent } from "./manage-work-area.component";
import { TableModule } from "primeng/table";
import { ManageRosterSummaryLineComponent } from "./manage-roster-summary-line.component";
import { RosterSummaryLineFormComponent } from "./roster-summary-line-form.component";
import { InputNumberModule } from "primeng/inputnumber";
import { ColorPickerModule } from "ngx-color-picker";
import { ManageWorkGroupPositionRosterType } from "./manage-workgroup-position-rostertype.component";
import { WorkGroupPositionRosterTypeFormComponent } from "./workgroup-position-rostertype-form.component";
import { WorkareaFormComponent } from "./workarea-form.component";
import { ManageRosterProjectComponent } from "./manage-roster-project.component";
import { RosterProjectFormComponent } from "./roster-project-form.component";
import { ChipModule } from "primeng/chip";
import { ManageProjectColumnsComponent } from "./manage-project-columns.component";
import { ManageTrainingCourseComponent } from "./manage-training-course.component";
import { ManageEmployerComponent } from "./manage-employer.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    SharedModule,
    AgGridModule.withComponents([]),

    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CheckboxModule,
    ChipModule,
    ColorPickerModule,
    ConfirmDialogModule,
    DropdownModule,
    FieldsetModule,
    InputNumberModule,
    InputTextModule,
    InputTextareaModule,
    MessageModule,
    MessagesModule,    
    MultiSelectModule,
    PanelModule,
    PickListModule,
    SplitterModule,
    TableModule,
    TabViewModule,
    ToastModule,
    ToolbarModule,
    TooltipModule,
    
    RouterModule.forChild([
      { path: 'manage-company', component: ManageEmployerComponent, canActivate: [AuthGuardService] },
      { path: 'system-data-management', component: SystemDataManagementComponent, canActivate: [AuthGuardService] },
      { path: 'client-management', component: ClientManagementComponent, canActivate: [AuthGuardService] },
      { path: 'manage-resource', component: ManageResourceComponent, canActivate: [AuthGuardService] },
      { path: 'manage-roster-code', component: ManageRosterCodeComponent, canActivate: [AuthGuardService] },
      { path: 'manage-holiday', component: ManageHolidayComponent, canActivate: [AuthGuardService] },
      { path: 'timesheet-breakdown-rule', component: TimesheetBreakdownRuleComponent, canActivate: [AuthGuardService] },
      { path: 'manage-roster-settings', component: ManageRosterSettingsComponent, canActivate: [AuthGuardService] },
      { path: 'manage-project-columns', component: ManageProjectColumnsComponent, canActivate: [AuthGuardService] },
      { path: 'manage-training-courses', component: ManageTrainingCourseComponent, canActivate: [AuthGuardService] }
    ])    
  ],
  declarations: [
    ClientManagementComponent,
    EntityActionComponent,
    EntityFormComponent,
    ManageResourceComponent,
    ManageRosterCodeComponent,
    ManageHolidayComponent,
    DeleteActionComponent,
    SystemDataManagementComponent,
    PayCategoryDropdownComponent,
    RosterCodeDropdownComponent,
    PositionDropdownComponent,
    BreakdownRuleDropdownComponent,
    BreakdownRuleLockComponent,
    PositionCheckboxComponent,
    TimesheetBreakdownRuleComponent,
    RosterCodeCheckboxComponent,
    ManageRosterSettingsComponent,
    ManageRosterCodeSettingsComponent,
    ManageRosterTypeComponent,
    RosterTypeFormComponent,
    ManageWorkAreaComponent,
    ManageRosterProjectComponent,
    ManageRosterSummaryLineComponent,
    ManageProjectColumnsComponent,
    RosterSummaryLineFormComponent,
    RosterProjectFormComponent,
    ManageWorkGroupPositionRosterType,
    WorkGroupPositionRosterTypeFormComponent,
    WorkareaFormComponent,
    ManageTrainingCourseComponent,
    ManageEmployerComponent
  ]
})
export class SystemSettingsModule{}